/**
 * ZEST-738 — New registration/auth flow design tokens.
 *
 * SCOPED ON PURPOSE: these values live only with the sign-up / verification /
 * 2FA / onboarding screens and must NOT be promoted into core/CssVariables.ts
 * without PM sign-off. The rest of the app keeps its current blue/Poppins
 * theme; this flow is the new navy/Inter look (see ZEST-738 Figma spec).
 */
export const AuthFlowColors = {
  pageBg: '#F1F5F9',
  heroStroke: '#E2E8F0',
  white: '#FFFFFF',
  cardBorder: '#CBD5E1',
  navy: '#1A3A5C', // primary button
  navyHover: '#16324F',
  navyText: '#19193A', // headings, labels, values
  textSecondary: '#323643',
  placeholder: '#64748B',
  link: '#0288D1',
  error: '#AD002A',
  errorBorder: '#FACFCD',
  success: '#007A55',
  featuredIconBg: '#EAF0FF',
  featuredIconRing: '#F6F9FF',
  footerText: '#626981',
  footerLink: '#4B5162',
} as const;

export const AuthFlowFont = "'Inter', sans-serif";
export const AuthFlowFooterFont = "'DM Sans', sans-serif";

/** Fixed card width from the Figma spec. */
export const AUTH_CARD_WIDTH = 520;
